import React, { useState, useEffect } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import { AnimatePresence } from "framer-motion/dist/framer-motion";
import useSound from "use-sound";
import { getRandomJokes } from "shared/api/jokes";
import TWJoining from "./screens/TWJoining";
import TWClues from "./screens/TWClues";
import TWGuessing from "./screens/TWGuessing";
import TWResult from "./screens/TWResult";
import TWJudging from "./screens/TWJudging";
import TWEvaluating from "./screens/TWEvaluating";
const TW = () => {
  const [joke, setJoke] = useState("Loading...");

  const {
    gameReducer: {
      currentUser,
      roomObj: {
        users,
        id: roomId,
        game_state: {
          correct_guess,
          status,
          clues,
          guess,
          mystery_word: { word } = {},
          active_player,
          judge_player
        } = {}
      }
    },
    paramsReducer: {
      gameObj: { screens } = {},
      paramsObj: { default_audio_effect } = {}
    }
  } = useSelector((state) => state);

  const [buzzer_sound] = useSound(default_audio_effect);

  const playerClues = clues?.map((clue) => {
    const user = users?.find((user) => user.player_id === clue.player_id);
    return {
      ...clue,
      profile_image: user.profile_image,
      display_name: user.display_name
    };
  });

  const currentPlayer = users?.find(
    (user) => user.user_id === currentUser?.userId
  );
  const clueSubmitted =
    clues?.find((clue) => clue.player_id === currentPlayer?.player_id) || {};
  const isActivePlayer = currentPlayer?.player_id === active_player;
  const isJudgePlayer = currentPlayer?.player_id === judge_player;

  useEffect(() => {
    getRandomJokes().then((data) => setJoke(data));
  }, [status]);

  return (
    <div className="tw-content">
      <AnimatePresence exitBeforeEnter>
        {status === "Joining" && <TWJoining key="TW_0" users={users} />}
        {status === "Clues" && (
          <TWClues
            key={_.isEmpty(clueSubmitted) ? "TW_1" : "TW_1.2"}
            word={word}
            joke={joke}
            clues={clues}
            roomId={roomId}
            screens={screens}
            buzzer_sound={buzzer_sound}
            currentPlayer={currentPlayer}
            clueSubmitted={clueSubmitted}
            isActivePlayer={isActivePlayer}
            default_audio_effect={default_audio_effect}
          />
        )}
        {status === "Judging" && (
          <TWJudging
            key="TW_2"
            isJudgePlayer={isJudgePlayer}
            word={word}
            roomId={roomId}
            joke={joke}
            playerClues={playerClues}
            isActivePlayer={isActivePlayer}
            screens={screens}
            buzzer_sound={buzzer_sound}
            default_audio_effect={default_audio_effect}
          />
        )}
        {status === "Guessing" && (
          <TWGuessing
            key="TW_3"
            isActivePlayer={isActivePlayer}
            isJudgePlayer={isJudgePlayer}
            clueSubmitted={clueSubmitted}
            word={word}
            joke={joke}
            roomId={roomId}
            playerClues={playerClues}
            screens={screens}
            buzzer_sound={buzzer_sound}
            default_audio_effect={default_audio_effect}
          />
        )}
        {status === "Evaluating" && (
          <TWEvaluating
            key="TW_4"
            isJudgePlayer={isJudgePlayer}
            joke={joke}
            word={word}
            activePlayerWord={guess}
            roomId={roomId}
            isActivePlayer={isActivePlayer}
            clueSubmitted={clueSubmitted}
            screens={screens}
            buzzer_sound={buzzer_sound}
            default_audio_effect={default_audio_effect}
          />
        )}
        {status === "Result" && (
          <TWResult
            key="TW_5"
            isJudgePlayer={isJudgePlayer}
            isActivePlayer={isActivePlayer}
            correctGuess={correct_guess}
            joke={joke}
            roomId={roomId}
            screens={screens}
            buzzer_sound={buzzer_sound}
            default_audio_effect={default_audio_effect}
          />
        )}
        {status === "Over" && (
          <TWJoining key="TW_6" users={users} isOver={true} />
        )}
      </AnimatePresence>
    </div>
  );
};

export default TW;
